import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_TEMAS_ACADEMICOS,
  ALL_TEMAS_ACADEMICOS,
  LOADING_ALL_TEMAS_ACADEMICOS,
} from './TemasAcademicosReducer';
import {
  allTemasAcademicosService,
  asignarTemaMateriasService,
  deleteTemaMateriasService,
  deleteTemasAcademicosService,
  oneTemasAcademicosService,
  saveTemasAcademicosService,
} from './TemasAcademicosService';

export const allTemasAcademicosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_TEMAS_ACADEMICOS, payload: true });
    const res = await allTemasAcademicosService(params);
    dispatch({ type: ALL_TEMAS_ACADEMICOS, payload: res.data });
    dispatch({ type: LOADING_ALL_TEMAS_ACADEMICOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_TEMAS_ACADEMICOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveTemasAcademicosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveTemasAcademicosService(id, data);
    notify(res.data.message);
    await allTemasAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoTemasAcademicosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_TEMAS_ACADEMICOS, payload: data });
};

export const oneTemasAcademicosAction = async (dispatch, id) => {
  try {
    const res = await oneTemasAcademicosService(id);
    await setActivoTemasAcademicosAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteTemasAcademicosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteTemasAcademicosService(id);
    notify(res.data.message);
    await setActivoTemasAcademicosAction(dispatch, null);
    await allTemasAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const asignarTemaMateriasAction = async ({ dispatch, notify }, data) => {
  try {
    const res = await asignarTemaMateriasService(data);
    notify(res.data.message);
    await oneTemasAcademicosAction(dispatch, data.idMateria);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteTemaMateriasAction = async (
  { dispatch, notify },
  idTema,
  id,
) => {
  try {
    const res = await deleteTemaMateriasService(id);
    notify(res.data.message);
    await oneTemasAcademicosAction(dispatch, idTema);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
